import React, {useEffect} from "react";
import { Box, Alert} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentTab } from "state/tabSlice";
import ChartOfAccountsTreeTable from "../tables/ChartOfAccountsTreeTable";
import PaymentTypesTable from "../tables/paymentTypesTable";
import ExpenseTypesTable from "../tables/expenseTypesTable";
import CustomTab from "components/Tabs/Tab";
import CashAndBankBalanes from "../tables/cash&BankBalances";
import PayrollBalances from "../tables/payrollBalances";
import SupplierPayablesList from "../tables/supplierPayablesList";
import CustomerRecievablesList from "../tables/customerRecievablesList";

const AccountingTab = () => {
  const dispatch = useDispatch();
  const [value, setValue] = React.useState(useSelector((state)=> state.tabReducer.currentTab['accountingTab']) );
  const handleChange = (event, newValue) => {
    setValue(newValue);
    dispatch(setCurrentTab({ name: "accountingTab", tab: newValue })); 
  };
  const [isSuccess, setIsSuccess] = React.useState(false);
  const [isFailed, setIsFailed] = React.useState(false);

  const tabComponents = [
    {Component: <ChartOfAccountsTreeTable />, label: "CHART OF ACCOUNTS", "index": 0},
    // {Component: <BalanceSheetMonthsTable />, label: "BALANCE SHEET", "index": 1},
    // {Component: <ProfitAndLossTable />, label: "PROFIT AND LOSS", "index": 2},
    {Component: <PaymentTypesTable />, label: "PAYMENT TYPES", "index": 1},
    {Component: <ExpenseTypesTable />, label: "EXPENSE TYPES", "index": 2},
    {Component: <CashAndBankBalanes setIsSuccess={setIsSuccess}/>, label: "CASH AND BANK BALANCES", "index": 3},
    {Component: <PayrollBalances setIsSuccess={setIsSuccess}/>, label: "PAYROLL BALANCES", "index": 4},
    {Component: <SupplierPayablesList setIsSuccess={setIsSuccess}/>, label: "SUPPLIER BALANCES", "index": 5},
    {Component: <CustomerRecievablesList setIsSuccess={setIsSuccess}/>, label: "CUSTOMER BALANCES", "index": 6},
  ] 

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsSuccess(false);
      setIsFailed(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, [isSuccess, isFailed]);

  return (
    <Box>
      {isSuccess ? (
        <Alert sx={{ m: "15px" }} variant="filled" severity="success">
          Operation was successful!
        </Alert>
      ) : isFailed ? (
        <Alert sx={{ m: "15px" }} severity="error">
          Operation was not successful!
        </Alert>
      ) : null}

      <CustomTab tabComponents={tabComponents} value={value} handleChange={handleChange}/>
    </Box>
  );
};

export default AccountingTab;
